import {
  LOCALENV,
  DEV,
  QA,
  UAT,
  PROD,
  MAINT,
} from "../components/common/config";
import { C2CConsole } from "./Helper/C2CConsole";
import { LOCALSTORAGEKEY } from "./Helper/localStorageUtils";

let socket = null;
let timeout1 = 250;

export const connect = (
  token,
  clinic_id,
  prevClinicId,
  user_id,
  socketResponseCallback,
  doctorList,
  user_type,
  reconnect
) => {
  const clinicIdFromLocalStorage = localStorage.getItem(
    LOCALSTORAGEKEY.CLINIC_ID
  );
  if (reconnect === "reconnect") {
    socket.close();
    socket = new WebSocket(getWSURL(token));
  } else {
    if (!socket) {
      socket = new WebSocket(getWSURL(token));
    } else {
      if (clinic_id) {
        if (clinic_id !== prevClinicId) {
          socket.close();
          socket = new WebSocket(getWSURL(token));
        }
      } else {
        socket.close();
        socket = new WebSocket(getWSURL(token));
      }
    }
  }

  let connectInterval;
  socket.onopen = () => {
    C2CConsole.log("Socket connected");
    timeout1 = 250; // reset timer to 250 on open of websocket connection
    clearTimeout(connectInterval);
    if (user_type === "staff" && !clinic_id) {
      doctorList.map((data) => {
        socketSubscription(clinic_id ?? clinicIdFromLocalStorage, data);
      });
    } else {
      socketSubscription(clinic_id ?? clinicIdFromLocalStorage, user_id);
    }
  };
  socket.onmessage = (res) => {
    if (res.data !== "null") {
      let data = JSON.parse(res.data);
      if (data?.id === "abha-token") {
        localStorage.setItem(
          LOCALSTORAGEKEY.ABHA_TOKEN_COUNT,
          data?.token_count
        );
      } else {
        socketResponseCallback(res);
      }
    }
  };
  socket.onclose = (e) => {
    C2CConsole.log(
      `Socket is closed. Reconnect will be attempted in ${Math.min(
        10000 / 1000,
        (timeout1 + timeout1) / 1000
      )} second.`,
      e.reason
    );
    timeout1 = timeout1 + timeout1; //increment retry interval
    // connectInterval = setTimeout(check, Math.min(10000, timeout1));
    connectInterval = setTimeout(() => {
      check(
        token,
        clinic_id,
        prevClinicId,
        user_id,
        socketResponseCallback,
        doctorList,
        user_type
      );
    }, Math.min(10000, timeout1));
  };
  // websocket onerror event listener
  socket.onerror = (err) => {
    C2CConsole.error(
      "Socket encountered error: ",
      err.message,
      "Closing socket"
    );
    socket.close();
  };
};

export const unsubscribeWebSocket = (
  clinic_id,
  user_id,
  doctorList,
  user_type
) => {
  C2CConsole.log("unsubscribeWebSocket");
  if (
    socket &&
    socket.readyState === 1 &&
    socket.readyState !== WebSocket.CLOSED
  ) {
    if (user_type === "staff" && !clinic_id) {
      doctorList.map((data) => {
        socketUnsubscribe(clinic_id, data);
      });
    } else {
      socketUnsubscribe(clinic_id, user_id);
    }
  }
};

// const check = () => {
//   if (!socket || socket.readyState === WebSocket.CLOSED) connect(); //check if websocket instance is closed, if so call `connect` function.
// };

const check = (
  token,
  clinic_id,
  prevClinicId,
  user_id,
  socketResponseCallback,
  doctorList,
  user_type
) => {
  if (!socket || socket.readyState === WebSocket.CLOSED)
    connect(
      token,
      clinic_id,
      prevClinicId,
      user_id,
      socketResponseCallback,
      doctorList,
      user_type,
      "reconnect"
    ); //check if websocket instance is closed, if so call `connect` function.
};

const socketSubscription = (clinic_id, user_id) => {
  C2CConsole.log("reconnect socket", clinic_id, user_id);
  // connection is ready
  if (socket && socket.readyState === 1) {
    socket.send(
      JSON.stringify({
        action: "subscribe",
        channel: clinic_id ? `clinic-${clinic_id}` : `doctor-${user_id}`,
        id: "subscribe",
        login_user_id: user_id,
      })
    );
  }
};

const socketUnsubscribe = (clinic_id, user_id) => {
  socket.send(
    JSON.stringify({
      action: "unsubscribe",
      channel: clinic_id ? `clinic-${clinic_id}` : `doctor-${user_id}`,
      id: "unsubscribe",
    })
  );
};

const getWSURL = (token) => {
  const envConstant =
    window.location.hostname === "localhost"
      ? LOCALENV
      : process.env.REACT_APP_ENV;
  switch (envConstant) {
    case DEV:
      return `wss://3ca7zwdsr9.execute-api.ap-south-1.amazonaws.com/dev?token=${token}`;
    case QA:
      return `wss://rx0jr1slec.execute-api.ap-south-1.amazonaws.com/qa?token=${token}`;
    case UAT:
      return `wss://t5ut6nwmgd.execute-api.ap-south-1.amazonaws.com/uat?token=${token}`;
    case PROD:
      return `wss://9e1d4o4awh.execute-api.ap-south-1.amazonaws.com/prod?token=${token}`;
    case MAINT:
      return `wss://wsfgy26ned.execute-api.ap-south-1.amazonaws.com/maint?token=${token}`;
    default:
      return `wss://3ca7zwdsr9.execute-api.ap-south-1.amazonaws.com/dev?token=${token}`;
  }
};
